import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';
import { NotificationManager } from 'react-notifications';
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import CropModal from '../shared/CropModal.jsx';

const styles = theme => ({
	h1: {
		color: '#0277bd',
		fontSize: '48px',
		fontWeight: 200,
		margin: 0,
	},
	icon: {
		fontSize: '48px',
		fontWeight: 200,
	},
});

class BarredAdd extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			first_name: '',
			last_name: '',
			pic_path: '',
			big_pic_path: '',
			indefinate: true,
			expires: moment()
				.add(1, 'M')
				.format('yyyy-MM-DD'),
		};
	}

	componentDidMount() {
		this.getBarred();
	}

	getBarred = () => {
		let that = this;
		if (this.props.match.params.id) {
			axios({
				method: 'get',
				url: '/api/getBarredById',
				params: {
					id: this.props.match.params.id,
				},
			}).then(function(response) {
				console.log('get user:', response);
				if (response.data) {
					response.data.pic_path = response.data.pic;
					that.setState({ ...response.data });
				} else {
					NotificationManager.error('Something Went Wrong', 'ERROR', 5000);
				}
			});
		}
	};

	signup = e => {
		e.preventDefault();
		let url = '/api/addBarred';
		if (this.props.match.params.id) url = '/api/editBarred';
		let that = this;
		axios({
			method: 'post',
			url: url,
			data: {
				_id: this.state._id,
				email: this.state.email,
				first_name: this.state.first_name,
				last_name: this.state.last_name,
				pic: this.state.pic_path,
				expires: this.state.expires,
				indefinate: this.state.indefinate,
			},
		}).then(function(response) {
			console.log('user info:', response);
			if (response.data.message === 'success') {
				if (that.props.match.params.id) {
					NotificationManager.success(response.data.description, 'USER EDITED', 5000);
					that.props.history.push('/barredList');
				} else NotificationManager.success(response.data.description, 'USER CREATED', 5000);
				that.setState({
					first_name: '',
					last_name: '',
					email: '',
					pic_path: '',
					big_pic_path: '',
					indefinate: true,
					expires: moment()
						.add(1, 'M')
						.format('yyyy-MM-DD'),
				});
			} else {
				NotificationManager.error(response.data.description, 'ERROR', 5000);
			}
		});
	};

	handleChange = event => {
		console.log('event:', event.target.value);
		this.setState({ [event.target.name]: event.target.value });
	};

	handleUnpublishedChange = event => {
		this.setState({ unpublished: event.value });
	};

	handleSelectChange = event => {
		console.log('event', event.value);
		this.setState({ indefinate: event.value });
	};

	changeMonth = month => {
		this.setState({ currentMonth: month });
	};

	setValues = values => {
		let val = [];
		_.each(values, (v, k) => {
			val[k] = moment(v).toDate();
		});
		this.setState({ publishDates: val });
	};

	uploadNewPic = e => {
		e.preventDefault();

		let description = 'pic_full';
		let key = 'user_id_fk';
		const formData = new FormData();
		formData.append('fileupload', e.target.files[0]);

		axios
			.post('/api/upload_file', formData, {})
			.then(res => {
				console.log("what's the res:", res);
				this.setState({ big_pic_path: res.data.path });
				this.setState({ cropToolShow: true });
			})
			.catch(error => {
				NotificationManager.error('Please choose a smaller sized file', 'File too large to upload');
			});
	};

	clickInput = field => {
		document.getElementById(field).click();
	};

	handleClose = () => {
		this.setState({ cropToolShow: false });
	};

	confirmCrop = () => {
		console.log('confirmed crop');
	};

	updatePicPath = path => {
		console.log('pic path updated', path);
		this.setState({ pic_path: path });
	};

	render() {
		const { list } = this.state;
		const { classes } = this.props;
		let show = { label: 'Indefinate', value: true };
		let unpublished = { label: 'Can View Unpublished Schedules', value: true };
		//let obj = this.state.files?.find(obj => obj.description === 'pic_cropped');
		if (!this.state.indefinate) show = { label: 'Expires', value: false };

		if (!this.state.unpublished) unpublished = { label: 'Unpublished Schedules are hidden', value: false };

		return (
			<span>
				{!this.props.match.params.id ? <h1 className={classes.h1}>Add Barred Customer</h1> : <h1 className={classes.h1}>Edit Barred Customer</h1>}
				<form action="/auth/signup" method="POST">
					<input type="text" placeholder="First Name" name="first_name" value={this.state.first_name} onChange={this.handleChange} />
					<input type="text" placeholder="Last Name" name="last_name" value={this.state.last_name} onChange={this.handleChange} />
					<br />
					<Select
						className="select"
						name="indefinate"
						onChange={this.handleSelectChange}
						value={show}
						options={[
							{ label: 'Indefinate', value: true },
							{ label: 'Expires', value: false },
						]}
					/>
					{!this.state.indefinate && (
						<TextField
							id="date"
							label="Expires"
							type="date"
							name="expires"
							defaultValue={moment(this.state.expires).format('YYYY-MM-DD')}
							className={classes.textField}
							onChange={this.handleChange}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					)}
					<br />
					<>
						<span className="cursor" onClick={() => this.clickInput('profilePicUpload')}>
							{this.state.pic_path != '' ? <img src={'/' + this.state.pic_path} /> : <div style={{ padding: '5', border: '1px solid black', width: 100, textAlign: 'centereveryt' }}>upload pic</div>}
						</span>

						<input name="profilePicUpload" id="profilePicUpload" label="Profile Pic" onChange={this.uploadNewPic} type="file" style={{ display: 'none' }} />

						<CropModal message="test crop" show={this.state.cropToolShow} onYesClick={this.confirmCrop} onNoClick={this.handleClose} onClose={this.handleClose} updatePicPath={this.updatePicPath} cancelText="Cancel" confirmText="Crop" image={this.state.big_pic_path} />
					</>
					<br />
					<br />
					<button onClick={this.signup}>{!this.props.match.params.id ? 'Submit' : 'Edit'}</button>
				</form>
			</span>
		);
	}
}

export default withStyles(styles, { withTheme: true })(BarredAdd);
